import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'

import { getActiveAccommodation } from '../../redux/reducers/activeAccommodation'
import { resetActiveAccommodation } from '../../redux/actions/setActiveAccommodation'
import AccommodationModal from '../../components/AccommodalModal/AccommodationModal'
import NorthstarAccommodationModal from '../../components/AccommodalModal/AccommodationDetailsModal'

const AccommodationsContainer = () => {
  const dispatch = useDispatch()
  const activeAccommodation = useSelector(getActiveAccommodation)

  const closeModal = () => {
    dispatch(resetActiveAccommodation())
  }

  const Modal = !_.isEmpty(
    _.get(activeAccommodation, 'viewExtensions.northstar')
  )
    ? NorthstarAccommodationModal
    : AccommodationModal

  return (
    <Modal
      accommodation={activeAccommodation}
      isOpen={activeAccommodation ? true : false}
      onClose={closeModal}
    />
  )
}

export default AccommodationsContainer
